// Main
import appleApps from "@/libs/backend/backendParams/requests/main/appleApps";
import auth from '@/libs/backend/backendParams/requests/main/auth';
import info from '@/libs/backend/backendParams/requests/main/info';
import roles from '@/libs/backend/backendParams/requests/main/roles';
import salesReport from '@/libs/backend/backendParams/requests/main/salesReport';
import statisticsReports from '@/libs/backend/backendParams/requests/main/statisticsReports';
import users from '@/libs/backend/backendParams/requests/main/users';
import usersGroups from '@/libs/backend/backendParams/requests/main/usersGroups';

// CloudFlare
import landingDomain from '@/libs/backend/backendParams/requests/cloudflare/landingDomain';
import landingRegions from '@/libs/backend/backendParams/requests/cloudflare/landingRegions';

// Astrology
import astroEvents from '@/libs/backend/backendParams/requests/astrology/astroEvents';
import biorhythms from '@/libs/backend/backendParams/requests/astrology/biorhythm/biorhythms';
import biorhythmTypes from '@/libs/backend/backendParams/requests/astrology/biorhythm/biorhythmTypes';
import cookies from '@/libs/backend/backendParams/requests/astrology/cookies';
import compatibilities from '@/libs/backend/backendParams/requests/astrology/compatibility/compatibilities';
import compatibilityTypes from '@/libs/backend/backendParams/requests/astrology/compatibility/compatibilityTypes';
import compatibilityScore from '@/libs/backend/backendParams/requests/astrology/compatibility/compatibilityScore';
import famousBabyModel from '@/libs/backend/backendParams/requests/astrology/famousBaby/famousBabyModel';
import famousBabyResult from '@/libs/backend/backendParams/requests/astrology/famousBaby/famousBabyResult';
import futureBaby from '@/libs/backend/backendParams/requests/astrology/futureBaby';
import horoscopeAnnuals from '@/libs/backend/backendParams/requests/astrology/horoscope/horoscopeAnnuals';
import horoscopeDailies from '@/libs/backend/backendParams/requests/astrology/horoscope/horoscopeDailies';
import horoscopeKeywords from '@/libs/backend/backendParams/requests/astrology/horoscope/horoscopeKeywords';
import horoscopeMonthlies from '@/libs/backend/backendParams/requests/astrology/horoscope/horoscopeMonthlies';
import horoscopeTypes from '@/libs/backend/backendParams/requests/astrology/horoscope/horoscopeTypes';
import houseDesctiption from '@/libs/backend/backendParams/requests/astrology/birthChart/houseDescription';
import meditationCategory from '@/libs/backend/backendParams/requests/astrology/meditation/meditationCategory';
import meditationResource from '@/libs/backend/backendParams/requests/astrology/meditation/meditationResource';
import moods from '@/libs/backend/backendParams/requests/astrology/moods';
import moonSigns from '@/libs/backend/backendParams/requests/astrology/moonSigns';
import numerologyMain from '@/libs/backend/backendParams/requests/astrology/numerology/numerologyMain';
import numerologyTypes from '@/libs/backend/backendParams/requests/astrology/numerology/numerologyTypes';
import anotherLifeModel from '@/libs/backend/backendParams/requests/astrology/anotherLife/anotherLifeModel';
import anotherLifeResult from '@/libs/backend/backendParams/requests/astrology/anotherLife/anotherLifeResult';
import palmLines from '@/libs/backend/backendParams/requests/astrology/palmLines';
import planetDesctiption from '@/libs/backend/backendParams/requests/astrology/birthChart/planetDescription';
import planetInSign from '@/libs/backend/backendParams/requests/astrology/birthChart/planetInSign';
import tarotCard from '@/libs/backend/backendParams/requests/astrology/tarot/tarotCard';
import tarotFortune from '@/libs/backend/backendParams/requests/astrology/tarot/tarotFortune';
import tarotResult from '@/libs/backend/backendParams/requests/astrology/tarot/tarotResult';
import signRelationship from '@/libs/backend/backendParams/requests/astrology/signRelationship';
import yesOrNo from '@/libs/backend/backendParams/requests/astrology/yesOrNo';
import zodiacDescriptions from '@/libs/backend/backendParams/requests/astrology/zodiacDescriptions';
import zodiacSigns from '@/libs/backend/backendParams/requests/astrology/zodiacSigns';
import appConfigs from '@/libs/backend/backendParams/requests/astrology/appConfigs';

// VPN
import accessLevels from '@/libs/backend/backendParams/requests/vpn/accessLevels';
import appleModels from "@/libs/backend/backendParams/requests/vpn/appleModels";
import blackListDevices from '@/libs/backend/backendParams/requests/vpn/blackListDevices';
import campaigns from '@/libs/backend/backendParams/requests/vpn/campaigns';
import campaignTds from "@/libs/backend/backendParams/requests/vpn/campaignTds";
import cities from '@/libs/backend/backendParams/requests/vpn/cities';
import clientApps from '@/libs/backend/backendParams/requests/vpn/clientApps';
import countries from '@/libs/backend/backendParams/requests/vpn/countries';
import dataCenters from '@/libs/backend/backendParams/requests/vpn/dataCenters';
import deviceTypes from "@/libs/backend/backendParams/requests/vpn/deviceTypes";
import landings from '@/libs/backend/backendParams/requests/vpn/landings';
import landingAttributes from '@/libs/backend/backendParams/requests/vpn/landingAttributes';
import masterServer from '@/libs/backend/backendParams/requests/vpn/masterServer';
import osDevices from "@/libs/backend/backendParams/requests/vpn/osDevices";
import rebillAnalytics from '@/libs/backend/backendParams/requests/vpn/rebillAnalytics';
import receipts from '@/libs/backend/backendParams/requests/vpn/receipts';
import statistics from '@/libs/backend/backendParams/requests/vpn/statistics';
import tariffs from '@/libs/backend/backendParams/requests/vpn/tariffs';
import tickets from '@/libs/backend/backendParams/requests/vpn/tickets';
import trackers from '@/libs/backend/backendParams/requests/vpn/trackers';
import trafficSources from '@/libs/backend/backendParams/requests/vpn/trafficSources';
import vpns from '@/libs/backend/backendParams/requests/vpn/vpns';
import mailSubject from '@/libs/backend/backendParams/requests/vpn/mailSubject';
import partnerPromoCodes from '@/libs/backend/backendParams/requests/vpn/partnerPromoCodes';
import partners from '@/libs/backend/backendParams/requests/vpn/partners';
import paymentProviderModels from '@/libs/backend/backendParams/requests/vpn/paymentProviderModels';
import premium from '@/libs/backend/backendParams/requests/vpn/premium';

// Subscriptions
import subscriptionsAppleModels from '@/libs/backend/backendParams/requests/subscriptions/appleModels';
import subscriptionsCampaigns from '@/libs/backend/backendParams/requests/subscriptions/campaigns';
import subscriptionsCampaignTds from '@/libs/backend/backendParams/requests/subscriptions/campaignTds';
import subscriptionsClientApps from '@/libs/backend/backendParams/requests/subscriptions/clientApps';
import subscriptionsCountries from '@/libs/backend/backendParams/requests/subscriptions/countries';
import subscriptionsLandings from '@/libs/backend/backendParams/requests/subscriptions/landings';
import subscriptionsOsDevices from '@/libs/backend/backendParams/requests/subscriptions/osDevices';
import subscriptionsStatistics from '@/libs/backend/backendParams/requests/subscriptions/statistics';
import subscriptionsTariffs from '@/libs/backend/backendParams/requests/subscriptions/tariffs';
import subscriptionsTrafficSources from '@/libs/backend/backendParams/requests/subscriptions/trafficSources';



// Path with parameters
const backendRequests = {
    // Main
    ...auth,
    ...info,
    ...roles,
    ...users,
    ...usersGroups,
    ...salesReport,
    ...appleApps,

    // CloudFlare
    ...landingDomain,
    ...landingRegions,

    // Astrology
    ...astroEvents,
    ...biorhythms,
    ...biorhythmTypes,
    ...cookies,
    ...compatibilities,
    ...compatibilityTypes,
    ...compatibilityScore,
    ...famousBabyModel,
    ...famousBabyResult,
    ...futureBaby,
    ...horoscopeAnnuals,
    ...horoscopeDailies,
    ...horoscopeKeywords,
    ...horoscopeMonthlies,
    ...horoscopeTypes,
    ...houseDesctiption,
    ...meditationCategory,
    ...meditationResource,
    ...moods,
    ...moonSigns,
    ...numerologyMain,
    ...numerologyTypes,
    ...anotherLifeModel,
    ...anotherLifeResult,
    ...palmLines,
    ...planetDesctiption,
    ...planetInSign,
    ...tarotCard,
    ...tarotFortune,
    ...tarotResult,
    ...signRelationship,
    ...yesOrNo,
    ...zodiacDescriptions,
    ...zodiacSigns,
    ...appConfigs,

    // VPN
    ...accessLevels,
    ...appleModels,
    ...blackListDevices,
    ...campaigns,
    ...campaignTds,
    ...cities,
    ...clientApps,
    ...countries,
    ...dataCenters,
    ...deviceTypes,
    ...landings,
    ...landingAttributes,
    ...masterServer,
    ...osDevices,
    ...rebillAnalytics,
    ...receipts,
    ...statistics,
    ...tariffs,
    ...tickets,
    ...trackers,
    ...trafficSources,
    ...vpns,
    ...mailSubject,
    ...partnerPromoCodes,
    ...partners,
    ...paymentProviderModels,
    ...premium,

    // Subscriptions
    ...subscriptionsAppleModels,
    ...subscriptionsCampaigns,
    ...subscriptionsCampaignTds,
    ...subscriptionsCountries,
    ...subscriptionsLandings,
    ...subscriptionsOsDevices,
    ...subscriptionsStatistics,
    ...subscriptionsTrafficSources,
    ...subscriptionsTariffs,
    ...subscriptionsClientApps,
    ...statisticsReports,
};

export default backendRequests;
